// extracted by mini-css-extract-plugin
export default {"container":"section_container__mh1eW","sectionTitle":"section_sectionTitle__bdYU+","sectionContent":"section_sectionContent__es-TX"};